/* eslint-disable jira/filename-case */
import log from '@atlassian/jira-common-util-logging/src/log.tsx';

type ResourceErrorOptions = {
	name?: string;
	skipSentry: boolean;
};

type ResourceErrorFields = {
	name?: string;
	message: string;
	component: string;
	skipSentry?: boolean;
};

class ResourceErrorClass extends Error {
	skipSentry: boolean;

	constructor(message: string, options: ResourceErrorOptions) {
		super(message);
		this.name = options.name || 'ResourceError';
		this.skipSentry = options.skipSentry;
	}
}

export const createResourceError = (
	{ name = 'ResourceError', message = '', component = '', skipSentry = false }: ResourceErrorFields,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	errorOverride?: any,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
	log.safeErrorWithoutCustomerData(component, message, errorOverride);

	if (errorOverride) {
		return errorOverride;
	}

	return new ResourceErrorClass(message, { name, skipSentry });
};
